export const GET_CLIENT_PAYMENT_SECRET_START = 'GET_CLIENT_PAYMENT_SECRET_START'
export const GET_CLIENT_PAYMENT_SECRET_END = 'GET_CLIENT_PAYMENT_SECRET_END'
export const GET_USER_CARDS_START = 'GET_USER_CARDS_START'
export const GET_USER_CARDS_END = 'GET_USER_CARDS_END'
export const SAVE_USER_CARD_START = 'SAVE_USER_CARD_START'
export const SAVE_USER_CARD_END = 'SAVE_USER_CARD_END'
export const UPDATE_USER_CARD_START = 'UPDATE_USER_CARD_START'
export const UPDATE_USER_CARD_END = 'UPDATE_USER_CARD_END'
export const DELETE_USER_CARD_START = 'DELETE_USER_CARD_START'
export const DELETE_USER_CARD_END = 'DELETE_USER_CARD_END'
export const GET_USER_CARD_START = 'GET_USER_CARD_START'
export const GET_USER_CARD_END = 'GET_USER_CARD_END'

// Bank Account Constants
export const GET_BANK_ACCOUNT_SETUP_INTENT_START = 'GET_BANK_ACCOUNT_SETUP_INTENT_START'
export const GET_BANK_ACCOUNT_SETUP_INTENT_END = 'GET_BANK_ACCOUNT_SETUP_INTENT_END'
export const GET_BANK_ACCOUNTS_START = 'GET_BANK_ACCOUNTS_START'
export const GET_BANK_ACCOUNTS_END = 'GET_BANK_ACCOUNTS_END'
export const SAVE_BANK_ACCOUNT_START = 'SAVE_BANK_ACCOUNT_START'
export const SAVE_BANK_ACCOUNT_END = 'SAVE_BANK_ACCOUNT_END'
export const UPDATE_BANK_ACCOUNT_START = 'UPDATE_BANK_ACCOUNT_START'
export const UPDATE_BANK_ACCOUNT_END = 'UPDATE_BANK_ACCOUNT_END'
export const DELETE_BANK_ACCOUNT_START = 'DELETE_BANK_ACCOUNT_START'
export const DELETE_BANK_ACCOUNT_END = 'DELETE_BANK_ACCOUNT_END'
export const SET_BANK_ACCOUNT_DEFAULT_START = 'SET_BANK_ACCOUNT_DEFAULT_START'
export const SET_BANK_ACCOUNT_DEFAULT_END = 'SET_BANK_ACCOUNT_DEFAULT_END'
